module.exports = __webpack_public_path__ + "static/img/quadrante_mama_direita.b04fcca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quadrante_mama_direita.png
// module id = 5iDR
// module chunks = 1